/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpResponse
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, Observable, of, tap, throwError } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { responseStatus } from '../constants/responseStatus.const';
import { ToasterService } from '../../services/toaster.service';
import { CacheService } from '../../services/cache.service';
// import { API_URLS } from '../constants/cache.const';

@Injectable({
  providedIn: 'root'
})
export class GetInterceptor implements HttpInterceptor {
  // private cachableUrls = Object.values(API_URLS);
  private cachableUrls: string[] = [];
  private isUnauthorizedMessageShown = false;
  constructor(
    private _toastrService: ToasterService,
    private router: Router,
    private cacheService: CacheService,
    private translateService: TranslateService
  ) { }

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    const isCachable =
      req.method === 'GET' &&
      this.cachableUrls.some((url) => req.url.startsWith(url));

    if (isCachable) {
      const cachedResponse = this.cacheService.get(req.urlWithParams);
      if (cachedResponse) {
        return of(
          new HttpResponse({
            body: cachedResponse,
            status: 200
          })
        );
      }
    }

    return next.handle(req).pipe(
      tap({
        next: (event) => {
          if (event instanceof HttpResponse && isCachable) {
            this.cacheService.set(req.urlWithParams, event.body);
          }
        }
      }),
      catchError((error: HttpErrorResponse) => {
        this.handleError(error);
        return throwError(() => error);
      })
    );
  }

  private handleError(error: HttpErrorResponse): void {
    let msg = error.error?.message || '';
    if (msg.includes('reassignToRoleId') || msg.includes('assigned to team members')) {
      msg = 'This role is currently assigned to active team members. Please reassign those team members to a different role before deleting it.';
    }

    switch (error.status) {
    case responseStatus.BADREQUEST:
      this._toastrService.errToastr(msg || error.error?.message);
      break;
    case responseStatus.UNAUTHORIZED:
    case responseStatus.FORBIDDEN:
      if (!this.isUnauthorizedMessageShown) {
        this.isUnauthorizedMessageShown = true;
        this._toastrService.errToastr(error.error?.message);
        setTimeout(() => {
          this.isUnauthorizedMessageShown = false;
        }, 1000);
        localStorage.clear();
        this.router.navigate(['/auth/login']);
      }
      break;
    case responseStatus.REQUESTTIMEOUT:
      this._toastrService.errToastr(error.error?.message);
      break;
    case responseStatus.INTERNALSERVERERROR:
      this._toastrService.errToastr(error.error?.message);
      break;
    case responseStatus.RequestTookMoreThanExpected:
      this._toastrService.errToastr(error.error?.message);
      break;
    default:
      this._toastrService.errToastr(
        this.translateService.instant('networkConnection')
      );
    }
  }
}

